var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54105 0.147461C9.26741 0.147461 12.5006 2.24891 14.1255 5.32973C15.756 3.03296 18.4379 1.53272 21.4716 1.53272H26.32V4.99588C26.32 9.96898 22.2889 14.0001 17.3158 14.0001H15.2379V15.3854H22.1642V25.0822C22.1642 26.6129 20.9244 27.8527 19.3937 27.8527H8.31158C6.78086 27.8527 5.54105 26.6129 5.54105 25.0822V15.3854H12.4674V12.6148H9.69684C4.34141 12.6148 0 8.27341 0 2.91799V0.147461H5.54105ZM19.3937 18.1559H8.31158V25.0822H19.3937V18.1559ZM23.5495 4.30325H21.4716C18.0292 4.30325 15.2379 7.09456 15.2379 10.5369V11.2296H17.3158C20.7582 11.2296 23.5495 8.43826 23.5495 4.99588V4.30325ZM5.54105 2.91799H2.77053C2.77053 6.7427 5.87213 9.8443 9.69684 9.8443H12.4674C12.4674 6.01959 9.36576 2.91799 5.54105 2.91799Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaseIcon);
export default __webpack_public_path__ + "static/media/leaseIcon.416d36b7bf584e047ddcafad29112491.svg";
export { ForwardRef as ReactComponent };